export default "__VITE_ASSET__80951706__"